import { registerMutation } from '@adornis/baseql/metadata/register.js';
import { getCollection } from '@adornis/baseql/server/collections.js';
import type { BaseQLSelectionSet } from '@adornis/baseql/utils/queryGeneration.js';
import { CurrentUserInfo } from '@adornis/users/db/currentUserInfo.js';
import { ClassRoom } from '../classroom.js';
import { Teacher } from '../teacher.js';
import { createClassroomForTeacher } from '../utils/classroom.js';

export const createClassroomMutation = registerMutation({
  operationName: 'createClassroomMutation',
  type: () => ClassRoom,
  params: [
    { name: 'name', type: () => String },
    { name: 'subject', type: () => String },
  ],

  resolve: (name: string, subject: string) => async (_gqlFields: BaseQLSelectionSet<ClassRoom>) => {
    const currentUser = await CurrentUserInfo.getMyself()({ _id: 1 });
    if (!currentUser?._id) {
      throw new Error('Nicht autorisiert: Kein User eingeloggt');
    }

    const teacherCollection = await getCollection(Teacher);
    const teacher = await teacherCollection.findOne({ userID: currentUser._id });
    if (!teacher) {
      throw new Error('Nicht autorisiert: Kein Lehrerprofil gefunden');
    }

    return createClassroomForTeacher(teacher._id, name, subject);
  },
});
